import { render } from "./AgroInputShop.vue?vue&type=template&id=5034619c&scoped=true"
import script from "./AgroInputShop.vue?vue&type=script&lang=js"
export * from "./AgroInputShop.vue?vue&type=script&lang=js"

import "./AgroInputShop.vue?vue&type=style&index=0&id=5034619c&lang=css"
import "./AgroInputShop.vue?vue&type=style&index=1&id=5034619c&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5034619c"]])

export default __exports__